export const vms_gen2 = [
  { name: "VM01 Zerschneider", location: "Azalea City – von Farbigel nach Käferorden" },
  { name: "VM02 Fliegen", location: "Route 16 – Haus nach 6. Orden" },
  { name: "VM03 Surfer", location: "Ebenholz City – von einem Mann im Haus" },
  { name: "VM04 Stärke", location: "Teak City – von einem Mann im Pokémon-Center" },
  { name: "VM05 Blitz", location: "Route 2 – Assistent (10 Pokémon gefangen)" },
  { name: "VM06 Whirlpool", location: "Teak City – vom Kimono-Girl-Meister" },
  { name: "VM07 Kaskade", location: "Route 27 – Haus mit Frau kurz vor der Pokémon-Liga" }
];
